import { DIALOG_TYPE } from '../types'

export function getRole(preventClose: boolean): DIALOG_TYPE {
	if (preventClose) {
		return DIALOG_TYPE.ALERT
	}

	return DIALOG_TYPE.DIALOG
}
